// extracted by mini-css-extract-plugin
export default {"form":"Ro-z","error":"So-z","disabled":"To-z"};